import { IFavoriteEntity } from '../../types/favoriteEntity';
import { IApplicationState } from '../../types/redux';

export const selectOfferByRealtyOfferIdForMap = (state: IApplicationState) =>
  state.offersByRealtyOfferId.folderOffers && state.offersByRealtyOfferId.folderOffers.length
    ? state.offersByRealtyOfferId.folderOffers[0]
    : ({} as IFavoriteEntity);
